// Load theme js files. src/index.js

// Frontend theme styles
import './scss/style.scss';

// Frontend theme scripts
import './js/subnav.js';
import './js/resource-page-nav.js';
import './js/small-header-gallery.js';
import './js/details-accordion-with-media.js';
import './js/scroll-direction.js'; // show/hide header on scroll
import './js/mega-menu.js';
import './js/share-url.js';

//import './js/gravity-forms-required-submit.js'; // Disable submit until required fields are filled

// Modal popups & video controls
import './js/legacy-bg-video-controls.js';
import './js/legacy-expanding-blocks.js';
import './js/legacy-modal-content-dialog.js';
import './js/legacy-modal-gallery-dialog.js';

// Legacy swiper patterns
import Swiper from './js/swiper/swiper-bundle.js'; // TODO: Update old Swiper 8.4.2 from 2022
import './js/swiper/cards-carousel.js';
//import './js/swiper/cards-gridder-filter.js'; // Remove?
import './js/swiper/carouselBlock.js';
import './js/swiper/galleryCarousel.js';

window.Swiper = Swiper; // Ensure Swiper is available globally
